<template>
  <div id="map-container">
    <p class="label-map">SECTORIZACIÓN
    <span v-show="!drawMode"
    class="label-no-save">HAY CAMBIOS SIN GUARDAR</span>
    </p>
    <div class="button-container">
      <i v-if="drawMode"
         class="fas fa-pen"
         @click="draw"/>
      <i v-else
         class="fas fa-save"
         @click="save"/>
    </div>
    <div id="route-map" :style="{ height }"></div>
  </div>
</template>

<script>
import GoogleMapsLoader from './config';

export default {
  name: 'MapZonesModifyV2',
  props: {
    polygon: {
      type: Array,
      default() {
        return [];
      },
    },
    lat: {
      type: Number,
      default: -33.435774,
    },
    lng: {
      type: Number,
      default: -70.660690,
    },
    height: {
      type: String,
      default: 'calc(100vh - 220px)',
    },
    width: {
      type: String,
      default: '100%',
    },
  },
  data() {
    return {
      drawMode: true,
      paths: [],
      mvcPaths: '',
      zoom: 12,
      editPoligon: false,
      editDraggable: false,
      // nueva
      clustering: [],
      google: null,
      infoWindows: [],
      map: null,
      markers: [],
      zoomControl: true,
      drawingManager: null,
      selectedShape: null,
      selectedColor: null,
      polyOptions: {
        strokeWeight: 1,
        fillOpacity: 0.45,
        editable: true,
        draggable: true,
      },
      style: [{
        elementType: 'geometry',
        stylers: [{ color: '#f5f5f5' }],
      }, {
        elementType: 'labels.icon',
        stylers: [{ visibility: 'true' }],
      }, {
        elementType: 'labels.text.fill',
        stylers: [{ color: '#616161' }],
      }, {
        elementType: 'labels.text.stroke',
        stylers: [{ color: '#f5f5f5' }],
      }, {
        featureType: 'administrative.land_parcel',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#bdbdbd' }],
      }, {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [{ color: '#eeeeee' }],
      }, {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#757575' }],
      }, {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [{ color: '#e5e5e5' }],
      }, {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#9e9e9e' }],
      }, {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{ color: '#ffffff' }],
      }, {
        featureType: 'road.arterial',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#757575' }],
      }, {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [{ color: '#dadada' }],
      }, {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#616161' }],
      }, {
        featureType: 'road.local',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#9e9e9e' }],
      }, {
        featureType: 'transit.line',
        elementType: 'geometry',
        stylers: [{ color: '#e5e5e5' }],
      }, {
        featureType: 'transit.station',
        elementType: 'geometry',
        stylers: [{ color: '#eeeeee' }],
      }, {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{ color: '#eaf4fe' }],
      }, {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#9e9e9e' }],
      }],
    };
  },
  mounted() {
    this.initMap();
    this.drawMode = true;
  },
  watch: {
  },
  methods: {
    initMap() {
      const element = document.getElementById('route-map');
      GoogleMapsLoader.load((google) => {
        this.google = google;
        this.map = new google.maps.Map(element, {
          center: new google.maps.LatLng(this.lat, this.lng),
          zoom: 10,
          styles: this.style,
          mapTypeControl: false,
          streetViewControl: false,
        });
        if (this.polygon.length > 0) this.updatePath(this.polygon);
      });
    },
    draw() {
      this.drawMode = false;
      this.deleteSelectedShape();
      this.drawingManager = new this.google.maps.drawing.DrawingManager({
        drawingMode: this.google.maps.drawing.OverlayType.POLYGON,
        drawingControl: false,
        markerOptions: {
          draggable: true,
        },
        polylineOptions: {
          editable: true,
          draggable: true,
        },
        polygonOptions: this.polyOptions,
        map: this.map,
      });
      this.google.maps.event.addListener(this.drawingManager, 'overlaycomplete', (e) => {
        const newShape = e.overlay;
        newShape.type = e.type;
        if (e.type !== this.google.maps.drawing.OverlayType.MARKER) {
          // Switch back to non-drawing mode after drawing a shape.
          this.drawingManager.setDrawingMode(null);
          // Add an event listener that selects the newly-drawn shape when the user
          // mouses down on it.
          this.google.maps.event.addListener(newShape, 'click', (ev) => {
            if (ev.vertex !== undefined) {
              if (newShape.type === this.google.maps.drawing.OverlayType.POLYGON) {
                const path = newShape.getPaths().getAt(ev.path);
                path.removeAt(ev.vertex);
                if (path.length < 3) {
                  newShape.setMap(null);
                }
              }
              if (newShape.type === this.google.maps.drawing.OverlayType.POLYLINE) {
                const path = newShape.getPath();
                path.removeAt(ev.vertex);
                if (path.length < 2) {
                  newShape.setMap(null);
                }
              }
            }
            this.setSelection(newShape);
          });
          this.setSelection(newShape);
        }
      });
      // eslint-disable-next-line
      this.google.maps.event.addListener(this.drawingManager, 'drawingmode_changed', this.clearSelection);
      this.google.maps.event.addListener(this.map, 'click', this.clearSelection);
      // eslint-disable-next-line
      // this.google.maps.event.addDomListener(document.getElementById('delete-button'), 'click', this.deleteSelectedShape);
    },
    getPolygonPathOld() {
      if (this.selectedShape != null) {
        // console.log('polygon: ', this.selectedShape.getPath().getArray());
        // eslint-disable-next-line
        const objSelectedShape = JSON.parse(JSON.stringify(this.selectedShape.getPath().getArray()));
        const poligonStr = [];
        objSelectedShape.forEach((e) => {
          poligonStr.push(`${e.lng} ${e.lat}`);
        });
        console.log('polygon: ', objSelectedShape);
        this.$emit('getPolygonPath', objSelectedShape);
        const coordinate = new this.google.maps.LatLng(-33.513539, -70.793181);
        const polygon = new this.google.maps.Polygon(this.selectedShape);
        console.log('aaaaa: ', this.google.maps
          .geometry.poly.containsLocation(coordinate, polygon));
        // d
        poligonStr.push(`${objSelectedShape[0].lng} ${objSelectedShape[0].lat}`);
        // const result = `POLYGON((${poligonStr.join(',')}))`;
      } else {
        const resultFail = '';
        this.$emit('getPolygonPath', resultFail);
      }
    },
    setSelection(shape) {
      this.selectedShape = shape;
    },
    clearSelection() {
      this.selectedShape = null;
    },
    deleteSelectedShape() {
      if (this.selectedShape) {
        this.selectedShape.setMap(null);
      }
    },
    centerMap(lng, lat, zoom) {
      this.map.setCenter(new this.google.maps.LatLng(lat, lng));
      this.map.setZoom(zoom);
    },
    updatePath(polygon) {
      // const bounds = new this.google.maps.LatLngBounds();
      // const poligon = poly.replace('POLYGON((', '').replace('))', '');
      // const coor = poligon.split(',');
      // const coorArray = [];
      // this.paths = coorArray;
      if (this.selectedShape !== null) {
        this.selectedShape.setMap(null);
      }
      const flightPath = new this.google.maps.Polygon({
        path: polygon,
        strokeWeight: 1,
        fillOpacity: 0.45,
        fillColor: '#000000',
      });
      this.setSelection(flightPath);
      this.selectedShape.setMap(this.map);
      // this.map.fitBounds(bounds);
    },
    save() {
      this.drawMode = true;
      const polygon = this.selectedShape === null ? [] : JSON
        .parse(JSON.stringify(this.selectedShape.getPath().getArray()));
      // console.log('arr ', polygon);
      // const poly = new this.google.maps.Polygon({ path: polygon });
      // console.log('polygon ', poly);
      // console.log(this.polygon);
      if (polygon.length > 0) {
        this.$notify.success({
          title: 'Polígono guardado con éxito',
        });
        this.$emit('save', polygon);
      } else {
        this.$notify.warning({
          title: 'No se aplicaron cambios',
          message: 'Ningún polígono dibujado',
        });
      }
      // this.clearSelection();
      this.updatePath(polygon);
      // const coordinate = new this.google.maps.LatLng(-33.513539, -70.793181);
      // console.log('match?uno: ', this.google
      // .maps.geometry.poly.containsLocation(coordinate, poly));
    },
  },
};
</script>

<style lang="scss" scoped>
  .label-map {
    margin: 0 0 8px 0;
    color: #606266;
    font-size: 10px;
  }
  .label-no-save {
    color: white;
    padding: 1px 9px;
    margin-left: 3px;
    border-radius: 12px;
    background-color: #f55e64;
  }
  div.button-container {
    z-index: 2;
    margin: 10px;
    user-select: none;
    border-radius: 2px;
    position: absolute;
    background-color: white;
    box-shadow: rgba(0, 0, 0, 0.3) 0 1px 4px -1px;
    .separator {
      padding: 7px 0;
      display: inline;
      border-right: 1px solid #dedcdc;
    }
    i {
      height: 40px;
      color: #656565;
      font-size: 18px;
      cursor: pointer;
      line-height: 2.2;
      text-align: center;
    }
    .fa-pen { width: 42px; }
    .fa-save { width: 46px; }
    i:hover { color: #474747; }
  }
</style>
